module.exports = __webpack_public_path__ + "static/heroOlympoUrbano-0cdda82ccb8f9736663d958e588a49d3.png";